<template>
    <div class="tr">
        <MenuSection>
            <ListItem link="search">Rent a Tool</ListItem>
            <ListItem link="error-page">Help</ListItem>
            <ListItem link="error-page">Insurance</ListItem>
            <ListItem link="error-page">Reviews</ListItem>
        </MenuSection>
        <MenuSection>
            <ListItem class="cf" link="error-page">
                <div class="flex items-center fr">
                    <div class="mid-gray mr3">
                        Hello, {{ user.name }}
                    </div>
                    <div>
                        <img style="width:50px;" src="@/assets/img/avatars/avatar_1.svg">
                    </div>
                </div>
            </ListItem>
        </MenuSection>
        <MenuSection>
            <ListItem link="dashboard">Dashboard</ListItem>
            <ListItem link="inbox-mobile">Inbox
                <Pill v-if="unreadCount" :count="unreadCount"/>
            </ListItem>
            <ListItem link="listing-start">List My Tools</ListItem>
            <ListItem link="rentals-listings-mobile">My Rentals & Listings</ListItem>
            <ListItem link="settings-mobile">Account Settings</ListItem>
            <ListItem @click="logoutClick()">Log Out</ListItem>
        </MenuSection>
        <MenuSection class="pv3 pr3">
            <img class="pl2 grow pointer" src="@/assets/img/social-media/icon_menu_facebook_black.svg"/>
            <img class="pl2 grow pointer" src="@/assets/img/social-media/icon_menu_twitter_black.svg"/>
            <img class="pl2 grow pointer" src="@/assets/img/social-media/icon_menu_instagram_black.svg"/>
            <img class="pl2 grow pointer" src="@/assets/img/social-media/icon_menu_pinterest_black.svg"/>
        </MenuSection>
        <MenuSection class="pa3 hover-bg-light-gray pointer">
            <span>Get in touch: </span><span class="b"><MailTo address="inquiry@tooliaba.com" subject="Inquiry"/></span>
        </MenuSection>
    </div>
</template>

<script>
import MenuSection from '@/components/header/nav-items/MenuSection.vue';
import ListItem from '@/components/controls/ListItem.vue';
import Pill from '@/components/controls/Pill.vue';
import MailTo from '@/components/global/MailTo.vue';
import { mapState, mapMutations } from 'vuex';

export default {
    components: {
        MenuSection,
        Pill,
        ListItem,
        MailTo
    },
    computed: {
        ...mapState('users', ['user']),
        ...mapState('messages', ['unreadCount'])
    },
    methods: {
        ...mapMutations('users', ['updateCurrentUser']),
        logoutClick() {
            this.$router.push({ path: '/' });
            this.updateCurrentUser(null);
            this.$auth.logout({
                makeRequest: true
            });
        }
    }
};
</script>
